import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import MobileScreen from '../screen'
import IOSScreen from '../ios-screen'
import AndroidScreen from '../android-screen'

const GoalRoutes = () => {

    return (
        <React.Fragment>
            <Route exact path={CLIENT_ENDPOINTS.MOBILE} component={MobileScreen} />
            <Route exact path={CLIENT_ENDPOINTS.MOBILE_IOS} component={IOSScreen} />
            <Route exact path={CLIENT_ENDPOINTS.MOBILE_ANDROID} component={AndroidScreen} />
        </React.Fragment>
    )
}

export default GoalRoutes